import { logApiEnvironmentDiagnostics } from "config/api.ts";
import { useEffect, useRef } from "react";
import { useGetEnvironmentQuery } from "features/environment/environmentApiSlice.ts";

const EnvironmentDiagnosticsLogger = () => {
  const { data, isFetching } = useGetEnvironmentQuery();
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current || isFetching) {
      return;
    }

    logApiEnvironmentDiagnostics({
      environmentName: data?.environmentName,
      diagnosticsEnabledFromApi: data?.isDiagnosticsEnabled,
    });

    hasLoggedRef.current = true;
  }, [data?.environmentName, data?.isDiagnosticsEnabled, isFetching]);

  return null;
};

export default EnvironmentDiagnosticsLogger;
